module.exports = __webpack_public_path__ + "img/1.d617fca7.jpg";